import { Kind, Type, TypeRegistry } from '@sinclair/typebox';
import { TypeCompiler } from '@sinclair/typebox/compiler';
import { UnsafeOptions } from '@sinclair/typebox/type';

/** */
export function StringEnumType<T extends string[]>(kind: string, members: [...T], options?: UnsafeOptions) {
  const schema = Type.Union(members.map((m) => Type.Literal(m)));
  const validator = TypeCompiler.Compile(schema);
  // console.log({ validator : validator.Code() });
  TypeRegistry.Set(kind, (schema, value) => validator.Check(value));

  return Type.Unsafe<T[number]>({
    [Kind]: kind,
    type: 'string',
    enum: members,
    ...options,
  });
}
